module.exports = __webpack_public_path__ + "static/media/bloodss.98872e79.png";